import { useState } from "react";
import {toast} from 'react-toastify';
import { FaArrowRight } from "react-icons/fa6";


import newsletter from "../Assets/newsletter-image4.jpg";
import config from '../helper/config';
import logocircle from "../Assets/logo-circle2.png";

import { isEmpty } from "../helper/common";
import { Subscriberadd } from "../Axios/user.axios";


export default function Subscriber() {

    const [EmailId, SetEmailId] = useState("");
    const [Error,SetError] = useState({})


    const OnSubscribe = async() => {
        if(isEmpty(EmailId)){
            SetError({EmailId:"Enter Email-id"});
            return toast.error("Enter Email-id");
        }
        else if(!config.EMAIL.test(EmailId)){
            SetError({EmailId:"Enter valid Email-id"})
            return toast.error("Enter valid Email-id");
        }
        let Resp = await Subscriberadd({EmailId:EmailId})
        console.log('Subscriberadd_resp',Resp)
        if(Resp?.status){
            toast.success(Resp?.msg)
            setTimeout(()=>{
                SetEmailId("")
            },1000)
        }
        else{
            toast.error(Resp?.msg)
        }
    }
    return (

        <div className="box-newsletter">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 mt-3 col-md-12">
                        <div className="box-image-newsletter">
                            <div className="">
                                <img className="img-main" src={newsletter} alt="Image NewsLetter" />
                                <div className="shape-2 image-1"><img src={logocircle} alt="Icon primary" /></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 mt-3">
                        <span className="font-lg color-brand-1">Newsletter</span>
                        <h2 className="color-brand-1 mt-2 mb-15">Subscribe our newsletter</h2>
                        <p className="font-md color-grey-500">By clicking the button, you are agreeing with our Term & Conditions</p>
                        <div className="form-newsletter mt-3 position-relative">
                            <form action="" className="newsletter-form" novalidate="novalidate">
                                <input type="email" name="email" placeholder="Enter your email..." value={EmailId||''} id="Emailid" onChange={(e)=>SetEmailId(e.target.value)} />
                                <button className="btn btn-submit-newsletter" type="button" onClick={()=>OnSubscribe()}>
                                    {/* <svg id="btn-arrow" className="w-6 h-6 icon-16" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                                                <div id="loading" role="status" className="page_speed_1987120936 spinner-border text-white loading-newsletter"></div> */}
                                    <FaArrowRight />
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}